import React from "react";
import abbottLogo from "../img/Abbott_logo.png";
import H2Logo from "../img/H2Logo.png";
import NoData from "../img/no-data.jpg";
import HeaderComponent from "./headerComponent";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div class="row w-100 g-0">
      <div class="col-12 d-none d-lg-block col-lg-5 bg-image vh-100 position-fixed">
        <div class="mask text-light d-flex flex-column p-5 vh-100 w-100">
          <div class="logo-div float-start">
            {/* <img src={abbottLogo} class="w-100" alt="abbott logo" /> */}
            <Link className="navbar-brand company-logo company-logo-base" to="/">
              {/* <img src={abbottLogo} alt="abbott logo" class="w-100" /> */}
            </Link>
          </div>
          <div class="mt-auto text-start">
            <h3 class="fw-bold text-uppercase">welcome to abbott</h3>
            <h3 class="fw-bold text-uppercase display-6 text-color-primary pb-5">
              product verification
            </h3>

            <span class="pt-5 text-uppercase">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 offset-lg-5 d-flex flex-column vh-100">
        <div
          class="collapse mobile-nav-bar-menu-show"
          id="navbarToggleExternalContent"
          data-bs-theme="dark"
        >
          <div class="bg-dark p-4 text-start">
            <span class="text-body-secondary text-uppercase">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>

        <nav class="navbar navbar-dark bg-dark py-3 d-block d-lg-none">
          <div class="container-fluid px-4">
            <Link className="navbar-brand company-logo company-logo-base-mobile" to="/">
              {/* <img src={abbottLogo} alt="abbott logo" height="25" /> */}
            </Link>
            <button
              class="navbar-toggler border-0 ms-auto px-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarToggleExternalContent"
              aria-controls="navbarToggleExternalContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
        </nav>

        <div class="d-block d-lg-none top-bg-img-container">
          <div class="no-data top-bg-img">
            <div class="no-data top-bg-img-overlay">
              <div class="pt-5 px-4 text-start">
                <h3 class="fw-bold text-uppercase text-color-white">
                  welcome to abbott
                </h3>
                <h3 class="fw-bold text-uppercase display-6 text-color-primary">
                  product verification
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-lg-4 pt-4 main-content-padding">
          <HeaderComponent />
        </div>

        <div class="col-12 w-100 mx-md-auto main-content-padding no-data-container">
          <div class="py-2 py-md-5 py-lg-5 my-md-3 my-lg-5 d-flex flex-column align-items-center justify-content-center border rounded no-data-content-div">
            <img
              src={NoData}
              class="w-25 opacity-50 px-md-5 mt-md-3"
              alt="no data"
            />
            <span class="fs-4 fw-semibold mb-1">Product Not Found</span>
            <span class="fs-6 fw-semibold mb-4">
              We couldn't find the product you were looking for. Try searching
              or scanning again.
            </span>
          </div>
        </div>

        <div class="position-fixed bottom-0 end-0">
          <div class="d-flex justify-content-end pb-2 main-content-padding">
            {/* <img src={H2Logo} alt="logo" height="40" /> */}
            <a 
              href="https://h2compute.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              class="d-flex align-items-end text-decoration-none"
              style={{ cursor: 'pointer' }}
            >
              <span class="d-flex align-items-end me-2 text-color-gray small">
                Powered by:{" "}
              </span>
              <span class="h2c-logo"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
